import React from 'react';

function NoLabOrderList() {
	return (
		<div className="practiceManagementForm" style={{ border: '1px solid #dadada'}}>
			<div className="noDataFound">
				<p>No Data Found</p>
			</div>
		</div>
	);
}
export default NoLabOrderList;
